'use client'

/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import Image from 'next/image'
import DarkArrow from '@public/images/icons/black-arrow.png'
import LightArrow from '@public/images/icons/white-arrow.png'
import styles from './testimonial.module.scss'
import { ITEM_WIDTH, VISIBLE_ITEMS } from './constants'

const TestimonialItems = ({ testimonialValues, theme, isMobile }) => {
  const testimonials = testimonialValues?.testimonialItems || []
  const [translateX, setTranslateX] = useState(0)
  const totalItems = testimonialValues?.testimonialItems.length

  const handleLeftClick = () => {
    setTranslateX((prev) => Math.min(prev + ITEM_WIDTH, 0))
  }

  const handleRightClick = () => {
    const maxTranslate = -(ITEM_WIDTH * (totalItems - VISIBLE_ITEMS))
    setTranslateX((prev) => Math.max(prev - ITEM_WIDTH, maxTranslate))
  }

  const lightThemeStyle = theme === 'light' ? styles.lightThemeContainer : ''
  const isLightTheme = theme === 'light'

  return (
    <>
      <div className={styles.testimonialWrapper}>
        <div
          className={styles.testimonialContent}
          style={{
            transform: `translateX(${translateX}px)`,
          }}
        >
        {testimonials.map((userReviewItem: any, index: number) => (
            <div
              className={`${styles.cardRootContainer} ${lightThemeStyle} `}
              key={`${userReviewItem.customerName}${index}`}>
              <div className={styles.authorContainer}>
                <div className={styles.authorPhoto}>
                  <Image
                    src={userReviewItem?.userProfilePicture?.data?.attributes?.url}
                    alt={`Author Profile Photo ${index}`}
                    width={48}
                    height={48}
                  />
                </div>
                <div className={styles.authorInfo}>
                  <p className={styles.authorName}>{userReviewItem.customerName}</p>
                  <small className={`${styles.authorTitle} ${isLightTheme && styles.lightThemeReview}`}>
                    {userReviewItem.userRatingRecordedDate}
                  </small>
                </div>
              </div>

              <div className={`${styles.userReview} ${isLightTheme && styles.lightThemeReview}`}>
                {userReviewItem.userRatingReview}
              </div>
            </div>
          ))}
      </div>
    </div>
      {!isMobile && (
        <div className={styles.paginationControls}>
          <button
            onClick={handleLeftClick}
            className={`${styles.arrowButton} ${styles[`${theme}Arrow`]}`}
            type='button'
          >
            <Image
              src={isLightTheme ? LightArrow : DarkArrow}
              alt="arrow"
              width={24}
              height={24}
              className={styles.arrowLeft}
            />
          </button>
          <button
            onClick={handleRightClick}
            className={`${styles.arrowButton} ${styles[`${theme}Arrow`]}`}
            type='submit'
          >
            <Image
              src={isLightTheme ? LightArrow : DarkArrow}
              alt="arrow"
              width={24}
              height={24}
            />
          </button>
        </div>
      )}
    </>
  )
}

export default TestimonialItems
